"use client";

import { TimelineContainer } from "./timeline-container";
import { CruiseItineraryInner } from "./cruise-itinerary-inner";
import { iCruiseLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function CruiseItinerary(
  props: iCruiseLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Cruise"}
      icon={(props.icon as any) || "ship"}
    >
      <CruiseItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
